/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 * The component for Login routing
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Andrey Dubov
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.0.0
 */
import { useLayoutEffect } from 'react';

import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import { createStructuredSelector } from 'reselect';

import appExternalRedirect from '@/main/modules/app/appExternalRedirect';

import { makeSelectAuthSSO } from '../../modules/app/appSelectors';
import { EModeSSO, IAuthSSO } from '../../modules/app/appTypes';
import PageAuth from '../../pages/PageAuth/Loadable';
import PageAuthProvider from '../../pages/PageAuth/PageAuthProvider';
import { makeSelectLoggedIn } from '../../pages/PageAuth/selectors/authSelectors';
import { IRootReducer } from '../../reducers/rootReducer';
import { RoutePath } from '../constants/routesConstants';

export const LoginRoute = (props: RouteComponentProps & IConnectedProps) => {
    useLayoutEffect(() => {
        if (props.authSSO.mode === EModeSSO.soho && !props.loggedIn) {
            // TODO обработать этот редирект в саге на авторизацию
            appExternalRedirect(props.authSSO.login);
        }
    }, [props.authSSO.login, props.authSSO.mode, props.loggedIn]);

    if (props.authSSO.mode === EModeSSO.sso) {
        window.location.href = props.authSSO.logout;
        return null;
    }

    if (props.loggedIn) {
        return <Redirect to="/" />;
    }

    return (
        <PageAuthProvider isServiceUser={false}>
            <Switch>
                <Route exact path={`${props.match.url}`}>
                    <PageAuth type="auth" />
                </Route>
                <Route exact path={`${props.match.url}${RoutePath.recovery}`}>
                    <PageAuth type="recovery" />
                </Route>
                <Route exact path={`${RoutePath.changePassword}`}>
                    <PageAuth type="changePassword" />
                </Route>
            </Switch>
        </PageAuthProvider>
    );
};

export interface IConnectedProps {
    authSSO: IAuthSSO;
    loggedIn: boolean;
}

const mapStateToProps = createStructuredSelector<IRootReducer, RouteComponentProps, IConnectedProps>({
    authSSO: makeSelectAuthSSO(),
    loggedIn: makeSelectLoggedIn(),
});

export default connect(mapStateToProps)(LoginRoute);
